'use client'

import React from 'react'

import { Award } from '../../icons'
import { cn } from '../../utils/cn'

export interface AwardMarkProps {
  /**
   * 受賞年度 (GYYM AWARDS {year})
   */
  year: number

  /**
   * Class name
   */
  className?: string
}

/**
 * GYYM AWARDS 受賞マーク (施設カード用・1行)
 *
 * 施設詳細画面用の部門別バッジは `AwardBadge` を使用する
 */
export const AwardMark = ({ year, className }: AwardMarkProps) => {
  return (
    <span
      className={cn(
        'inline-flex h-[22px] w-fit shrink-0 items-center gap-1 rounded-full bg-[#0F1413] px-1.5 py-1',
        className,
      )}
    >
      <Award className="shrink-0" fill="#EBCC00" />
      <span className="whitespace-nowrap text-[10px] leading-none tracking-[0.5px] text-white">
        GYYM AWARDS {year} 受賞
      </span>
    </span>
  )
}
